(function () {
    const config = {
        breakpoint: 1024,
        maxLines: 3,
        selectors: {
            content: '.articleLookbook-des',
            learnMore: '.learn-more-description a',
            learnMoreDescription: '.learn-more-description'
        }
    };

    // Check if URL is SearchPage "/collections/shop?q"
    if (window.location.href.includes("/collections/shop")) {
        return;
    }

    let element, learnMoreDescription, learnMoreLink;

    function isMobileOrTablet() {
        return window.matchMedia(`(max-width: ${config.breakpoint}px)`).matches;
    }

    function getMaxHeight(element, lines) {
        const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
        return `${lineHeight * lines}px`;
    }

    function setupTextClamping() {
        element.style.maxHeight = getMaxHeight(element, config.maxLines);
        element.style.overflow = 'hidden';
    }

    function setupLearnMoreClick() {
        if (learnMoreLink) {
            learnMoreLink.addEventListener('click', () => {
                element.style.maxHeight = 'none';
                learnMoreDescription.style.display = 'none';
            });
        }
    }

    function init(attempts) {
        if (attempts <= 0) {
            console.log('collection-learn-more.js: Error: Required elements not found in the DOM');
            return;
        }

        element = document.querySelector(config.selectors.content);
        learnMoreDescription = document.querySelector(config.selectors.learnMoreDescription);
        learnMoreLink = document.querySelector(config.selectors.learnMore);

        if (element && learnMoreDescription) {
            setupTextClamping();
            setupLearnMoreClick();
        } else {
            setTimeout(() => init(attempts - 1), 100);
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
            if (isMobileOrTablet()) {
                init(3);
            }
        }, 100);
    });

})();
